import { defineComponent as _defineComponent } from 'vue'
import FrkLogo from './FrkLogo.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'FrkNav',
  setup(__props) {


return { __sfc: true,FrkLogo }
}

})